import { render, staticRenderFns } from "./CareerPortalForm.vue?vue&type=template&id=2b23c308&scoped=true&"
import script from "./CareerPortalForm.vue?vue&type=script&lang=js&"
export * from "./CareerPortalForm.vue?vue&type=script&lang=js&"
import style0 from "./CareerPortalForm.vue?vue&type=style&index=0&id=2b23c308&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b23c308",
  null
  
)

/* custom blocks */
import block0 from "./CareerPortalForm.vue?vue&type=custom&index=0&blockType=i18n&lang=yml&locale=en"
if (typeof block0 === 'function') block0(component)
import block1 from "./CareerPortalForm.vue?vue&type=custom&index=1&blockType=i18n&lang=yml&locale=ru"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VCard,VDialog,VImg})
